import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p443756950150270976',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
